import React, { Component, PropTypes } from 'react';
import { Menu, Table, Button, Modal, Row, Col, Badge, Spin, Input, Form, Pagination } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import { SortIcon } from '../../components';
import { Icon, TransactionList } from 'components';
import { TableHelper } from 'helpers/Table';
import { getTransactionList } from 'data/teacher';
import { connect } from 'react-redux';

import moment from 'moment';
import Utils from 'utils/utils';
import { formatPvCode } from 'utils/formatting';

import classes from '../styles/teacher/TeacherRevenue.module.scss';

const pageLimit = 20;

export default class TeacherWithdrawal extends Component {
  constructor() {
    super();
    this.onClickRow = this.onClickRow.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.state = {
      collapseMobile: [],
      showModal: false,
      transactions: {},
      loading: false,
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    const transactions = await getTransactionList(this.props.teacher._id);
    this.setState({ transactions, loading: false });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onClickRow(record, index) {
    console.log(record, index);
    // this.setState({
    //   showModal: true,
    //   selectedRow: record,
    //   isAddNew: false,
    // });
  }
  onChangePage = async (page) => {
    this.setState({ loading: true });
    const transactions = await getTransactionList(this.props.teacher._id, _.merge(this.getCurrentQuery(), { page }));
    this.setState({
      page: page,
      transactions,
      loading: false,
    });
  };

  onReload = async () => {
    this.setState({ loading: true });
    const transactions = await getTransactionList(this.props.teacher._id, this.getCurrentQuery());
    this.setState({
      transactions,
      loading: false,
    });
  };

  onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onReload);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onReload);
    }
  };

  getCurrentQuery() {
    return {
      page: this.state.page || 1,
      sortBy: this.state.sortBy,
    };
  }
  columns = [
    {
      ...TableHelper.datetimeColumn('Request Date', 'createdAt'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Withdrawal\nCode', 'code'),
      render: (value, record) => (
        <div>
          <Link to={`/withdraw/${record._id}`}>
            <span>{Utils.FormatNumberLength(value, 6)} </span>
          </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
    },
    {
      ...TableHelper.defaultColumn('Bank', 'bankName'),
    },
    {
      ...TableHelper.defaultColumn('A/C No.', 'bankAccount'),
    },

    {
      ...TableHelper.priceColumn('Payout', 'withdrawAmount'),
    },
    {
      ...TableHelper.datetimeColumn('Tran.\nDate', 'approvedDate'),
      sorter: true,
    },

    {
      ...TableHelper.defaultColumn('PV No.', 'pvCode'),
      render: (value, record) => {
        return formatPvCode(record);
      },
      renderExcel: (value, record) => formatPvCode(record),
    },
    {
      ...TableHelper.defaultColumn('Status', 'status'),
      sorter: true,
    },
  ];

  renderContentTable() {
    const transactions = _.map(this.state.transactions.results || [], (transaction, key) => {
      transaction.key = key;
      return transaction;
    });
    return (
      <div>
        <Table columns={this.columns} dataSource={transactions} bordered pagination={false} onRowClick={this.onClickRow} onChange={this.onTableChange} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.transactions.count} />
      </div>
    );
  }

  render() {
    return (
      <Spin tip="Loading" size="large" spinning={!!this.state.loading}>
        <div className="content">{this.renderContentTable()}</div>
      </Spin>
    );
  }
}

connect((state) => ({}), {
  // openModal,
  // verify,
  getTransactionList,
  // approveOrder,
})(Form.create()(TeacherWithdrawal));
